import { Trans, useLingui } from '@lingui/react/macro';

import InlineText from '@/design_system/Typography/InlineText';
import IconFile from '@/icons/File.svg';
import { BaseNotification } from '@/layouts/App/Navbar/NotificationList/components/BaseNotification/BaseNotification';
import type { TNotificationOfType } from '@/models/notification';

export const PendingServiceChoiceNotification = ({
  notification,
}: {
  notification: TNotificationOfType<'pending_service_choice'>;
}) => {
  const { t } = useLingui();

  const reference = notification.request.reference;

  return (
    <BaseNotification
      icon={<IconFile />}
      type="new"
      notification={notification}
      notificationLabel={t({
        id: 'notification.pending-service-choice.label',
        message: `Pending diagnosis for request ${reference}`,
      })}
      notificationHeader={(color) => (
        <Trans id="notification.pending-service-choice">
          <InlineText weight="medium" color={color}>
            You
          </InlineText>{' '}
          have a new request awaiting diagnosis
        </Trans>
      )}
    />
  );
};
